export default [
  // Dashboard and Member
  {
    header: 'Dashboard and Member',
    resource: 'User',
  },
  {
    title: 'แดชบอร์ด',
    route: 'dashboard-partner',
    icon: 'icon fad fa-chart-line',
    resource: 'User',
  },
  {
    title: 'รายการฝากออโต้',
    route: 'deposit',
    icon: 'icon fad fa-comments-alt-dollar',
    resource: 'User',
  },
  {
    title: 'รายการฝากโดยแอดมิน',
    route: 'deposit-fromadmin',
    icon: 'icon fad fa-comments-alt-dollar',
    resource: 'User',
  },
  {
    title: 'รายการถอน',
    route: 'withdraw',
    icon: 'icon fad fa-hand-holding-usd',
    resource: 'User',
  },
  {
    title: 'โยกเงิน',
    route: 'movecredit',
    icon: 'icon fad fa-hand-holding-usd',
    resource: 'Agadmin',
  },
  {
    title: 'รายการลูกค้า',
    route: 'member',
    icon: 'icon fad fa-users-crown',
    resource: 'User',
  },
  {
    header: 'Dashboard Detail',
    resource: 'Agadmin',
  },
  {
    title: 'ข้อมูลธุรกรรม',
    route: 'dashboard-detail',
    icon: 'icon fad fa-chart-line',
    resource: 'Agadmin',
  },
  // {
  //   title: 'ฝาก-ถอน',
  //   route: 'deposit-withdraw',
  //   icon: 'icon fad fa-money-check-edit-alt',
  //   resource: 'Agadmin',
  // },
  {
    header: 'Invite Friend',
    resource: 'Agadmin',
  },
  {
    title: 'แนะนำ (เซียน)',
    route: 'invite-friend',
    icon: 'icon fad fa-user-friends',
    resource: 'Agadmin',
  },
  {
    title: 'ส่งข้อความ SMS',
    route: 'send-sms',
    icon: 'icon fad fa-sms',
    resource: 'Agadmin',
  },
  {
    header: 'Lucky wheel',
    resource: 'User',
  },
  {
    title: 'ตั้งค่ากงล้อเสี่ยงโชค',
    route: 'wheel-setting',
    icon: 'icon fad fad fa-dharmachakra',
    resource: 'User',
  },
  {
    title: 'รายการเล่นกงล้อเสี่ยงโชค',
    route: 'wheel-history',
    icon: 'icon fad fad fa-dharmachakra',
    resource: 'User',
  },
  // AG Admin Management
  {
    header: 'SBOBET Setting',
    resource: 'SBO',
  },
  {
    title: 'โต๊ะ SBOBET',
    route: 'sbobet-table',
    icon: 'icon fad fa-trophy-alt',
    resource: 'SBO',
  },
  {
    title: 'ตั้งค่า SBOBET',
    route: 'sbobet-setting',
    icon: 'icon fad fa-trophy-alt',
    resource: 'Agadmin',
  },

  // {
  //   title: 'รายงาน Win/Lose',
  //   route: 'report',
  //   icon: 'icon fad fa-trophy-alt',
  //   resource: 'Agadmin',
  // },

  {
    header: 'AG Admin Management',
    resource: 'Agadmin',
  },
  {
    title: 'ธนาคาร',
    route: 'bank',
    icon: 'icon fad fa-analytics',
    resource: 'Agadmin',
  },
  {
    title: 'ช่องทางรู้จัก',
    route: 'channel',
    icon: 'icon fad fa-ad',
    resource: 'Agadmin',
  },
  {
    title: 'จัดการบัญชีผู้ใช้',
    route: 'admin-management',
    icon: 'icon fad fa-address-card',
    resource: 'Agadmin',
  },
  {
    title: 'ประวัติการเข้าใช้งาน',
    route: 'log-admin',
    icon: 'icon fad fa-address-book',
    resource: 'Agadmin',
  },
  // {
  //   title: 'จัดการบัญชีเอเย่นต์',
  //   route: 'admin-agent-management',
  //   icon: 'icon fad fa-user-secret',
  //   resource: 'Agadmin',
  // },
  {
    title: 'โปรโมชั่น',
    route: 'promotion',
    icon: 'icon fad fa-gift-card',
    resource: 'Agadmin',
  },
  {
    title: 'จัดการเอเย่นต์',
    route: 'setting',
    icon: 'icon fad fa-users-cog',
    resource: 'Agadmin',
  },
  {
    title: 'ประวัติหน้าจัดการเอเย่นต์',
    route: 'history',
    icon: 'icon fad fa-file-alt',
    resource: 'Agadmin',
  },

  // SMS Status
  {
    header: 'Error List',
    resource: 'User',
  },
  {
    title: 'รายการฝากไม่สำเร็จ',
    route: 'waiting-dep',
    icon: 'icon fad fa-exclamation',
    resource: 'User',
  },
  {
    title: 'รายการคืนเงิน',
    route: 'deposit-admin',
    icon: 'icon fad fa-comments-alt-dollar',
    resource: 'User',
  },
  {
    header: 'SMS Status',
    resource: 'User',
  },
  {
    title: 'SMS ฝาก',
    route: 'sms-deposit',
    icon: 'icon fad fa-comment-alt-dollar',
    resource: 'User',
  },
  {
    title: 'SMS ถอน',
    route: 'sms-withdraw',
    icon: 'icon fad fa-comment-alt-dollar',
    resource: 'User',
  },
  {
    title: 'SMS All',
    route: 'sms-all',
    icon: 'icon fad fa-comment-alt-dollar',
    resource: 'Agadmin',
  },
  {
    title: 'SMS OTP',
    route: 'sms-otp',
    icon: 'icon fad fa-comment-alt-exclamation',
    resource: 'User',
  },

  {
    title: 'True Money Wallet',
    route: 'true-money',
    icon: 'icon fad fa-comment-alt-lines',
    resource: 'User',
  },
  {
    title: 'KBANK STATEMENT',
    route: 'kbank-statement',
    icon: 'icon fad fa-university',
    resource: 'User',
  },
  // {
  //   title: 'KBANK LIVE',
  //   route: 'kbank-live',
  //   icon: 'icon fad fa-university',
  //   resource: 'User',
  // },
  {
    title: 'SCB Connect',
    route: 'scb-connect',
    icon: 'icon fad fa-university',
    resource: 'User',
  },
  {
    title: 'SCB Statement',
    route: 'statement',
    icon: 'icon fad fa-money-check',
    resource: 'User',
  },
  // Setting
  // {
  //   header: 'Admin Management',
  //   resource: 'Agadmin',
  // },
  // {
  //   title: 'Agent List',
  //   route: 'agent-list',
  //   icon: 'SettingsIcon',
  //   resource: 'Agadmin',
  // },
]
